<output class="skeleton" aria-busy="true">
  <span class="bone title"></span>

  @switch (shape) {
  @case ('pie') {
  <div class="pie">
    <span class="bone disc"></span>

    <div class="legend">
      @for (row of rows; track row) {
      <span class="bone line"></span>
      }
    </div>
  </div>
  }

  @case ('line') {
  <span class="bone area"></span>
  }

  @case ('table') {
  <div class="table">
    @for (row of rows; track row) {
    <div class="row">
      <span class="bone cell"></span>
      <span class="bone cell"></span>
      <span class="bone cell short"></span>
    </div>
    }
  </div>
  }

  @case ('heatmap') {
  <div class="grid">
    @for (cell of cells; track cell) {
    <span class="bone"></span>
    }
  </div>
  }

  @case ('kpi') {
  <div class="kpi">
    <span class="bone value"></span>
    <span class="bone line"></span>
    <span class="bone line short"></span>
  </div>
  }

  @case ('block') {
  <span class="bone fill"></span>
  }
  
  @default {
  <div class="bars">
    @for (height of bars; track $index) {
    <span class="bone" [style.height.%]="height"></span>
    }
  </div>
  }
  }
</output>